<template>
  <Popover
    ref="popoverRef"
    :append-to="appendTo"
    :pt="mergedPt"
    v-bind="$attrs"
  >
    <template #default>
      <slot />
    </template>
  </Popover>
</template>

<script lang="ts" setup>
import { Popover } from 'primevue'
import { computed, useTemplateRef } from 'vue'

import {
  DEFAULT_TWN_POPOVER_PROPS,
  type TwnPopoverProps
} from '@/components/atoms/prime/popover/twn-popover/TwnPopover.types'
import usePrimeVuePtMerge from '@/composables/use-prime-vue-helpers/usePrimeVuePtMerge.ts'

const props = withDefaults(defineProps<TwnPopoverProps>(), DEFAULT_TWN_POPOVER_PROPS)

const popoverRef = useTemplateRef<InstanceType<typeof Popover>>('popoverRef')

const defaultPt = {}

const mergedPt = computed(() => {
  return usePrimeVuePtMerge(defaultPt, props.pt).value
})

defineExpose({
  toggle: (event: Event) => popoverRef.value?.toggle(event),
  show: (event: Event) => popoverRef.value?.show(event),
  hide: () => popoverRef.value?.hide(),
  // Re-places the panel; call it after content that loads in changes the panel's height.
  align: () => popoverRef.value?.alignOverlay()
})
</script>
